import { Layout, Modal, Paragraph } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';

interface PopupProps {
  shown: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmationModal = ({ shown, onClose, onConfirm }: PopupProps) => {
  return (
    <Modal
      title=""
      hideTitle
      buttonConfirmText={t('step3:confirmationModal:confirm')}
      buttonCancelText={t('step3:confirmationModal:cancel')}
      id="confirmationModal"
      onConfirm={onConfirm}
      onCancel={onClose}
      onClose={onClose}
      shown={shown}
      asPortal
      center
    >
      <Layout>
        <Layout.Item>
          <Paragraph> {t('step3:confirmationModal:text1')} </Paragraph>
          <Paragraph> {t('step3:confirmationModal:text2')} </Paragraph>
        </Layout.Item>
      </Layout>
    </Modal>
  );
};
